var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_983_5315)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 26V38M31 21.88L30 26H35.83C36.1405 26 36.4467 26.0723 36.7244 26.2111C37.0021 26.35 37.2437 26.5516 37.43 26.8C37.6163 27.0484 37.7422 27.3367 37.7977 27.6422C37.8533 27.9477 37.8369 28.2619 37.75 28.56L35.42 36.56C35.2988 36.9754 35.0462 37.3404 34.7 37.6C34.3538 37.8596 33.9327 38 33.5 38H20C19.4696 38 18.9609 37.7893 18.5858 37.4142C18.2107 37.0391 18 36.5304 18 36V28C18 27.4696 18.2107 26.9609 18.5858 26.5858C18.9609 26.2107 19.4696 26 20 26H22.76C23.1321 25.9998 23.4967 25.8958 23.813 25.6997C24.1292 25.5036 24.3844 25.2232 24.55 24.89L28 18C28.4716 18.0058 28.9357 18.1182 29.3578 18.3286C29.7799 18.539 30.1489 18.8421 30.4374 19.2152C30.7259 19.5883 30.9263 20.0218 31.0237 20.4832C31.1212 20.9446 31.113 21.4221 31 21.88Z",
    stroke: "#02080E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_983_5315",
    x1: 52,
    y1: -4.5,
    x2: 20.5,
    y2: 61.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#D2F3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E2F4D3",
    stopOpacity: 0.926897
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7AE",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.789589e1b3173b065dfb201f5a58707d.svg";
export { ForwardRef as ReactComponent };